









import { Component, Vue, Prop } from 'vue-property-decorator'
import { jobDetailsLocalisationKeys } from '@/features/job/job.localisation'
import { uploadLocalisationKeys } from '@/features/upload/upload.localisation'
import { UPLOAD_NAME } from '@/features/upload/upload.router'

@Component
export default class JobListHeader extends Vue {
  private translations = jobDetailsLocalisationKeys
  private uploadTranslations = uploadLocalisationKeys

  handleClick () {
    this.$router.push({ name: UPLOAD_NAME })
  }
}
